
module.exports.getConfig = function()
{
    return {
                applicationId: 'Amigos.App.Id',
           }
}